<svg width="81" height="24" viewBox="0 0 81 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="81" height="24" rx="12" fill="#333333"/>
<rect x="64" y="7" width="10" height="10" rx="5" fill="#666666"/>
</svg>
